import {gql} from '@apollo/client';

import {assert} from 'Asserts';
import {getApolloClient} from 'graphql-client/ApolloClient';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {
  updateRequestV2Definition,
  UpdateRequestV2DefinitionParams,
} from 'processes/requests_v2/network/RequestV2DefinitionDAO';
import {RequestV2DefinitionPageQuery} from 'processes/requests_v2/request-v2-definition/__generated/RequestV2DefinitionPageQuery';

export type RequestV2DefinitionDetails = ExtractByTypename<
  RequestV2DefinitionPageQuery['requestV2Definition'],
  'RequestV2DefinitionNode'
>;

export const REQUEST_V2_DEFINITION_PAGE_QUERY = gql`
  query RequestV2DefinitionPageQuery($requestV2DefinitionId: StrictString!)
  @skipAudit
  @engComponent(name: WORKFLOWS) {
    requestV2Definition(id: $requestV2DefinitionId) {
      ...RequestV2DefinitionGraphQL
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('RequestV2Definition').fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export async function updateAndCacheRequestV2Definition(
  params: UpdateRequestV2DefinitionParams,
  loadingMessage: string
): Promise<void> {
  const {requestV2Definitions} = await updateRequestV2Definition(params, loadingMessage);

  assert(requestV2Definitions.length === 1, 'Expected exactly one request definition to be updated', {
    requestV2Definitions,
  });

  writeRequestV2DefinitionUpdateToCache(requestV2Definitions[0]);
}

export function writeRequestV2DefinitionUpdateToCache(requestV2Definition: RequestV2DefinitionDetails): void {
  getApolloClient().writeQuery({
    query: REQUEST_V2_DEFINITION_PAGE_QUERY,
    data: {
      requestV2Definition,
    },
    variables: {
      requestV2DefinitionId: requestV2Definition.id,
    },
  });
}
